import React, { ForwardRefRenderFunction } from 'react';

import styles from './Checkbox.module.scss';

type CheckboxProps = {
  id?: string;
  className?: string;
  label?: string;
  size?: 'small' | undefined;
  isRequired?: boolean;
  checked?: boolean;
  onChange?: (arg: any) => void;
  name?: string;
  disabled?: boolean;
  value?: any;
  rbf?: string;
}

const InnerComponent: ForwardRefRenderFunction<HTMLInputElement, CheckboxProps> = (
  ({ id, className, label, size, isRequired, rbf, ...props }, ref) => (
    <label
      className={[styles.container, className, styles[size]].filter(Boolean).join(' ')}
      htmlFor={id}
      data-test-id={`checkbox${id ? '-' + id : ''}`}
      data-rbf={rbf || `checkbox${id ? '-' + id : ''}`}
    >
      <input
        data-test-id={`checkbox-input${id ? '-' + id : ''}`}
        type="checkbox"
        id={id}
        ref={ref}
        {...props}
      />
      <span className={styles.checkmark}/>
      <span className={styles.label}>{label}{isRequired && '*'}</span>
    </label>
  )
);

InnerComponent.displayName = 'Checkbox';

// TODO-TYPESCRIPT : trouver un moyen d'enlever ce any
const Checkbox = React.forwardRef(InnerComponent) as any;
export default Checkbox;
